export default __webpack_public_path__ + "static/payment-app-0e5247ac8d153289c1fbd0171e39a8f2.png";